import React, { Component } from "react";

import { MONSTER_SIZES } from "constants.js";
import { Checkbox, FormWithChildren, TextInput, NumberInput, Select, Image } from "library";

export default class PlayerMetaData extends React.Component {
	render() {
		var monster = this.props.monster;

		var monster_data = {
			name: monster.name,
			dnd_class: monster.dnd_class_id,
			dnd_subclass: monster.dnd_subclass_id,
			dnd_race: monster.dnd_race_id,
			level: monster.level,
			size: monster.size,
		};

		var content = (
			<FormWithChildren
				className="player-metadata header col-12"
				defaults={monster_data}
				setGlobalState={this.props.update_monster}
				globalStateName={"player_metadata"}
				autoSetGlobalState={true}
			>
				<TextInput key="name" name="name" className="player-name" sneaky_input={true} />
				<div key="top-block" className="top-block">
					<div key="top-block-text" className="top-block-text">
						<div key="level" className="player-level inline-block">
							{"Level: "}
							<NumberInput key="level" name="level" sneaky_input={true} />
						</div>
						<br />
						<div key="dnd_class" className="player-class inline-block">
							{"Class: "}
							<Select
								key="dnd_class"
								name="dnd_class"
								sneaky_input={true}
								name="dnd_class"
								optionsUrl={"/api/compendium/DnDClass/"}
								optionsUrlMap={{
									text: "{DnDClass.name}",
									value: "{DnDClass.id}",
								}}
							/>
						</div>
						<div key="dnd_subclass" className="player-subclass inline-block">
							{"Subclass: "}
							<Select
								key="dnd_subclass"
								name="dnd_subclass"
								sneaky_input={true}
								optionsUrl={"/api/compendium/DnDSubClass/"}
								optionsUrlMap={{
									text: "{DnDSubClass.name}",
									value: "{DnDSubClass.id}",
								}}
							/>
						</div>
						<br />

						<div key="size" className="size inline-block">
							{"Size: "}
							<Select key="size" name="size" sneaky_input={true} options={MONSTER_SIZES} />
						</div>

						<div key="dnd_race" className="player-race inline-block">
							{"Race: "}
							<Select
								key="dnd_race"
								name="dnd_race"
								sneaky_input={true}
								optionsUrl={"/api/compendium/DnDRace/"}
								optionsUrlMap={{
									text: "{DnDRace.name}",
									value: "{DnDRace.id}",
								}}
							/>
						</div>
					</div>
				</div>
			</FormWithChildren>
		);

		return content;
	}
}
